import { useMemo } from 'react'
import { UserInfoHS } from 'src/commons/store/UserStore'

/**
 * 
 * 获取vip的状态 和 vip到期时间
 * @return {isVip} 当前用户是否为bip
 * @return {vipDate} 当前用户的vip到期时间
 */
const useVipStatus = () => {
  const {isVip, vipDate, isExpeVip, isForeverVip, isYearVip} = useMemo(() => {
    const userInfo = UserInfoHS.SuccessResult
    if (userInfo) {
      return {
        isVip: userInfo.vip === 2,
        vipDate: userInfo.vip_date || '',
        isExpeVip: userInfo.vip === 2 && userInfo.super_vip_type === 'expe',
        isYearVip: userInfo.vip === 2 && userInfo.super_vip_type === 'year',
        isForeverVip: userInfo.vip === 2 && userInfo.super_vip_type === 'forever',
      }
    }
    return {
      isVip: false,
      vipDate: '',
      isExpeVip: false,
      isYearVip: false,
      isForeverVip: false
    }
  }, [UserInfoHS.SuccessResult])
  return {isVip, vipDate, isExpeVip, isForeverVip, isYearVip}
}

export default useVipStatus